'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiSocialSkype = function TiSocialSkype(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm34.4 22.2c0.1-0.7 0.2-1.4 0.2-2.1 0-4.1-1.4-7.6-4.2-10.4-2.8-2.9-6.3-4.4-10.2-4.4-0.5 0-1 0-1.4 0.1-1.2-0.6-2.6-0.9-4-0.9-2.7 0-5.1 1-7 2.9-1.8 1.9-2.8 4.3-2.8 7 0 1.4 0.3 2.7 0.8 3.9-0.1 0.6-0.1 1.2-0.1 1.8 0 4.1 1.4 7.6 4.2 10.4 2.8 2.9 6.3 4.4 10.3 4.4 0.4 0 0.9 0 1.4-0.1 1.2 0.5 2.4 0.7 3.6 0.7 2.7 0 5.1-1 7-3 1.8-1.9 2.8-4.3 2.8-7 0-1.1-0.2-2.2-0.6-3.3z m-8.6 3.4c-0.4 0.7-1.2 1.3-2.2 1.8-1 0.4-2.2 0.6-3.5 0.6-1.6 0-2.9-0.3-4-0.9-0.8-0.4-1.4-1-1.8-1.7-0.5-0.7-0.7-1.4-0.7-2.1 0-0.4 0.1-0.7 0.4-1 0.3-0.3 0.7-0.5 1.2-0.5 0.3 0 0.7 0.1 1 0.4 0.3 0.3 0.5 0.6 0.6 1 0 0 0.3 0.4 0.7 1.2 0.1 0.2 0.4 0.4 0.9 0.7 0.4 0.2 0.9 0.3 1.6 0.3 0.9 0 1.7-0.2 2.3-0.6 0.5-0.4 0.8-0.9 0.8-1.5 0-0.4-0.2-0.8-0.5-1-0.3-0.3-0.7-0.6-1.1-0.7-0.2-0.1-0.3-0.1-0.6-0.2-0.2 0-0.4-0.1-0.7-0.2-0.3 0-0.6-0.1-0.8-0.1-1.1-0.3-2.1-0.6-2.9-0.9-0.7-0.3-1.4-0.8-1.9-1.5-0.5-0.6-0.7-1.4-0.7-2.3 0-0.8 0.2-1.6 0.7-2.3 0.5-0.7 1.3-1.2 2.2-1.5 1-0.4 2-0.6 3.3-0.6 0.9 0 1.7 0.2 2.5 0.4 0.8 0.3 1.4 0.6 1.9 1 0.5 0.4 0.8 0.8 1.1 1.2 0.2 0.5 0.3 1 0.3 1.3 0 0.4-0.1 0.8-0.4 1.1-0.4 0.3-0.7 0.5-1.2 0.5-0.4 0-0.7-0.1-1-0.3-0.1-0.2-0.3-0.5-0.6-0.9-0.2-0.5-0.5-0.9-1-1.3-0.4-0.3-1-0.4-1.9-0.4-0.8 0-1.4 0.1-1.9 0.5-0.5 0.3-0.7 0.6-0.7 1 0 0.3 0.1 0.5 0.3 0.7 0.1 0.2 0.4 0.4 0.6 0.6 0.2 0.1 0.5 0.2 0.9 0.3 0.1 0.1 0.3 0.1 0.7 0.2 0.3 0.1 0.6 0.1 0.9 0.2 0.4 0.1 1.2 0.3 2.4 0.6 0.7 0.3 1.3 0.6 1.9 0.9 0.6 0.4 1 0.9 1.3 1.4 0.3 0.6 0.4 1.3 0.4 2 0 1-0.3 1.8-0.8 2.6z' })
        )
    );
};

exports.default = TiSocialSkype;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/social-skype.js
// module id = 2188
// module chunks = 0